<template>
    <v-card class="elavation-1" >
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <v-layout v-if="!viewedByOwner" row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Requested By :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            <v-chip @click="viewUserProfile(cashadvances_detail, $store.state.userId)" style="margin:-5px 0px 0px -5px;">
                                <v-avatar>
                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(cashadvances_detail.userId)"></v-img>
                                </v-avatar>
                                {{cashadvances_detail.name}} 
                            </v-chip>
                        </v-flex>  
                    </v-layout>
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Purpose :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            {{cashadvances_detail.cashAdvanceType}} 
                        </v-flex>  
                    </v-layout>    
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Total Amount :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                        PHP {{numFormat.formatNumber(cashadvances_detail.totalAmount)}} 
                        </v-flex>  
                    </v-layout>   
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Calculate By :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            {{cashadvances_detail.calculationType==1?'Number of months to pay':'Monthly deduction amount'}} 
                        </v-flex>  
                    </v-layout>
                    <v-layout v-if="cashadvances_detail.calculationType==1" row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Number of Months to Pay :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            {{cashadvances_detail.paymentTerms}} {{cashadvances_detail.paymentTerms==1?'Month':'Months'}} @ 
                            PHP {{numFormat.formatNumber(cashadvances_detail.totalAmount/cashadvances_detail.paymentTerms)}} per month
                        </v-flex>  
                    </v-layout>
                    <v-layout v-if="cashadvances_detail.calculationType==2" row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Monthly deduction amount :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            PHP {{numFormat.formatNumber(cashadvances_detail.monthlyDeductionAmount)}} 
                        </v-flex>  
                    </v-layout>
                </v-flex>
                <v-flex xs12 sm6>
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Payment Start Date :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            {{cashadvances_detail.paymentStart | moment('MMM YYYY')}}
                        </v-flex>  
                    </v-layout>
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Last Payment Date :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            {{cashadvances_detail.paymentSchedule[cashadvances_detail.paymentSchedule.length-1].dueOn | moment('MMM DD, YYYY')}}
                        </v-flex>  
                    </v-layout>
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Total Computed :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            PHP {{numFormat.formatNumber(totalComputed)}}
                        </v-flex>  
                    </v-layout>
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Total Paid :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            PHP {{numFormat.formatNumber(totalPaid)}}
                        </v-flex>  
                    </v-layout>
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            No. of Payments :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            {{totalPayments}}
                        </v-flex>  
                    </v-layout>
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Comments :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            {{cashadvances_detail.description}}
                        </v-flex>  
                    </v-layout>
                </v-flex> 
            </v-layout>
        </v-card-text>              
    </v-card>
</template>

<script>
import numFormat from '@/common/num_format'
import commonfn from '@/common/functions'
import awsS3Helper from '@/helpers/aws-s3'

export default {     
    name: 'MyCashAdvances',
    metaInfo: {
        title: 'My Cash Advances',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, create My Cash Advances' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    props: ['cashadvances_detail','viewedByOwner'],
    components: {},   
    data () {
        return {}
    },
    methods: {
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId) this.$router.push(`/myprofile`)
            else this.$router.push(`/hr/employees/${data.userId}`)
        },
    },
    created() {
        this.numFormat = numFormat
        this.commonfn = commonfn
        this.awsS3Helper = awsS3Helper
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
        totalComputed() {
            var total = this.cashadvances_detail.paymentSchedule
                        .filter(x => x.status !== commonfn.getStatusCode('On Hold'))
                        .map(x => x.amountDue)
                        .reduce((prev,next)=>prev+next)
            return total
        },
        totalPaid() {
            var total = 0.00
            var paidList = this.cashadvances_detail.paymentSchedule.filter(x => {
                return x.status == commonfn.getStatusCode('Paid')
            })
            if (paidList.length > 0)
                total = paidList.map(x => x.amountDue).reduce((prev,next)=>prev+next)
            
            return total
        },
        totalPayments() {
            return this.cashadvances_detail.paymentSchedule.length
        },
    }
}
</script>
<style scoped>
.form-row {
    padding:0px 20px 0px 50px;
}
.form-row-mobile {
    padding:0px 20px 0px 20px;
}
</style>